import { FC } from 'react';
import {
  ClothesFinderContentStoryblok,
  ClothesFinderMainContentStoryblok,
  FinderResultContentStoryblok,
} from 'storyblok-types';
import { ClothesFinderMainContent } from 'pages/StoryBlok/ClothesFinder/MainContent';
import { FinderResults } from 'pages/StoryBlok/Finders/Results';
import { IServerProps } from 'pages/StoryBlok/types';

export const ClothesFinder: FC<{
  blok: ClothesFinderContentStoryblok;
  serverProps?: IServerProps;
}> = ({ blok, serverProps }) => {
  const mainContentBlok = blok?.content?.find(
    ({ component }) => component === 'clothesFinderMainContent',
  ) as ClothesFinderMainContentStoryblok;

  const finderResultBlok = blok?.content?.find(
    ({ component }) => component === 'finderResultContent',
  );

  return finderResultBlok && serverProps?.queryParams?.size ? (
    <FinderResults
      blok={finderResultBlok as FinderResultContentStoryblok}
      serverProps={serverProps}
    />
  ) : (
    <ClothesFinderMainContent
      blok={mainContentBlok as ClothesFinderMainContentStoryblok}
      serverProps={serverProps}
    />
  );
};
